import type { NexusSnapshot } from "@barmetvault/shared";
import {
  PageHeader,
  AgentCard,
  StatusBadge,
  EmptyState,
  ErrorState,
  PermissionDenied,
  DataTable,
} from "../components/hub/OperationalUI";
import { useHubResource } from "./useHubResource";
export default function NexusPage({
  title = "IA / Agentes",
}: {
  title?: string;
}) {
  const result = useHubResource<NexusSnapshot>("/hub/nexus");
  if (result.state === "denied") return <PermissionDenied />;
  return (
    <section className="hub-page">
      <PageHeader title={title} subtitle="Nexus Core · Orquestación interna">
        <StatusBadge status={result.data?.state ?? "UNVERIFIED"} />
      </PageHeader>
      {result.state === "error" && <ErrorState retry={result.retry} />}
      <section className="hub-card">
        <h2>Runtime de agentes (Python)</h2>
        <p>
          Conexión pendiente. Las herramientas se ejecutarán con permisos
          explícitos y auditoría; Secrets permanece cifrado en el cliente.
        </p>
      </section>
      <h2>Agentes registrados</h2>
      {result.data?.agents.length ? (
        <div className="hub-grid">
          {result.data.agents.map((agent) => (
            <AgentCard key={agent.id} agent={agent} />
          ))}
        </div>
      ) : (
        <EmptyState
          title="Sin agentes verificados"
          detail="Conecta el runtime para consultar agentes y capacidades autorizadas."
        />
      )}
      <h2>Skills, MCP y tools</h2>
      <DataTable
        rows={[
          ...(result.data?.skills ?? []),
          ...(result.data?.mcp ?? []),
          ...(result.data?.tools ?? []),
        ]}
        rowKey={(row) => row.id}
        columns={[
          { title: "Capacidad", render: (row) => row.name },
          { title: "Permiso", render: (row) => row.requiredPermission },
        ]}
      />
      <h2>Ejecuciones</h2>
      <DataTable
        rows={result.data?.executions ?? []}
        rowKey={(row) => row.requestId}
        columns={[
          { title: "Solicitud", render: (row) => row.requestId },
          { title: "Resultado", render: (row) => row.status },
        ]}
      />
    </section>
  );
}
